import { __awaiter, __generator, __read, __spread } from "tslib";
import Vue from 'vue';
var m = {
  namespaced: true,
  state: function state() {
    return {
      rankList: {
        list: [],
        loaded: false,
        requesting: false
      },
      info: null,
      inviteCard: null,
      couponList: []
    };
  },
  mutations: {
    concatList: function concatList(state, list) {
      var _a;

      (_a = state.rankList.list).push.apply(_a, __spread(list));
    },
    setListLoaded: function setListLoaded(state, loaded) {
      state.rankList.loaded = loaded;
    },
    setListReq: function setListReq(state, req) {
      state.rankList.requesting = req;
    },
    setInfo: function setInfo(state, info) {
      state.info = info;
    },
    setInviteCard: function setInviteCard(state, card) {
      state.inviteCard = card;
    },
    setCouponList: function setCouponList(state, list) {
      state.couponList = list;
    }
  },
  actions: {
    /**
     * 获取排行榜
     * @param {} offset
     * @param {} count
     * @param {} forceUpdate
     */
    getRankList: function getRankList(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var offset = _b.offset,
          count = _b.count,
          _c = _b.forceUpdate,
          forceUpdate = _c === void 0 ? false : _c;
      return __awaiter(this, void 0, void 0, function () {
        var wrap, list, end, response, rdata;
        return __generator(this, function (_d) {
          switch (_d.label) {
            case 0:
              wrap = state.rankList;

              if (wrap.requesting || wrap.loaded && !forceUpdate) {
                return [2
                /*return*/
                ];
              }

              if (forceUpdate) {
                wrap.loaded = false;
                wrap.list = [];
              }

              list = wrap.list;
              end = offset + count;

              if (end <= list.length) {
                return [2
                /*return*/
                ];
              }

              if (offset < list.length) {
                offset = list.length;
                count = end - offset;
              }

              commit('setListReq', true);
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/temp_activity/period_14_tesla/rank', {
                params: {
                  offset: offset,
                  count: count
                }
              })];

            case 1:
              response = _d.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('concatList', rdata.data);

                if (rdata.data.length < count) {
                  commit('setListLoaded', true);
                }
              }

              commit('setListReq', false);
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取活动信息
     * @param {} forceUpdate
     */
    getActivityInfo: function getActivityInfo(_a, forceUpdate) {
      var state = _a.state,
          commit = _a.commit;

      if (forceUpdate === void 0) {
        forceUpdate = false;
      }

      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              if (state.info && !forceUpdate) {
                return [2
                /*return*/
                ];
              }

              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/temp_activity/period_14_tesla/info')];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setInfo', rdata.data);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取邀请卡
     * @param {} forceUpdate
     */
    getInviteCard: function getInviteCard(_a, forceUpdate) {
      var state = _a.state,
          commit = _a.commit;

      if (forceUpdate === void 0) {
        forceUpdate = false;
      }

      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              if (state.inviteCard && !forceUpdate) {
                return [2
                /*return*/
                , {
                  status: 0
                }];
              }

              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/temp_activity/period_14_tesla/invite_card')];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setInviteCard', rdata.data.url);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取奖券列表
     * @param {} forceUpdate
     */
    getCouponList: function getCouponList(_a, forceUpdate) {
      var state = _a.state,
          commit = _a.commit;

      if (forceUpdate === void 0) {
        forceUpdate = false;
      }

      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              if (state.couponList && !forceUpdate) {
                return [2
                /*return*/
                ];
              }

              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/temp_activity/period_14_tesla/coupon_list')];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setCouponList', rdata.data);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    }
  }
};
export default m;